<template>
  <div>
    <div v-for="(row, rowIndex) in renderedRows" :key="rowIndex">

      <!-- Sección full-width (type 1) -->
      <div
        v-if="row.type === 'full'"
        class="first-section"
        :class="firstSectionClass"
        :style="{ backgroundColor: row.sections[0].background_color || '#ffffff' }"
      >
        <div class="container">
          <div
            v-for="section in row.sections"
            :key="section.id"
            class="single-column"
            :class="{ 'content-text': section.content && !section.image }"
          >
            <div
              v-if="section.content && !section.image"
              v-html="section.content"
            ></div>
            <div
              v-else-if="section.image && !section.content"
              class="background-image"
              :style="{ backgroundImage: `url(${section.image})` }"
            ></div>
          </div>
        </div>
      </div>

      <!-- Secciones en columnas (type 2) -->
      <div v-else class="second-section">
        <div class="container">
          <div class="row">
            <div
              v-for="section in row.sections"
              :key="section.id"
              class="col-md-6 col-sm-12"
            >
              <div
                v-if="section.content && !section.image"
                v-html="section.content"
                class="section-column"
                :style="{
                  backgroundColor: section.background_color || null,
                }"
              ></div>
              <div
                v-else-if="section.image && !section.content"
                class="background-image"
                :style="{ backgroundImage: `url(${section.image})` }"
              ></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "BlockComponent",
  props: {
    block: {
      type: Object,
      required: true,
    },
    firstSectionClass: {
      type: String,
      default: "class-default",
    },
  },

  setup(props) {
    const renderedRows = computed(() => {
      const sorted = [...props.block.sections].sort((a, b) => a.order - b.order);
      const rows = [];
      let columnRow = null;

      for (const section of sorted) {
        if (section.type === 1) {
          if (columnRow) {
            rows.push(columnRow);
            columnRow = null;
          }
          rows.push({ type: "full", sections: [section] });
        } else if (section.type === 2) {
          if (!columnRow) columnRow = { type: "columns", sections: [] };
          columnRow.sections.push(section);
        }
      }

      if (columnRow) rows.push(columnRow);

      return rows;
    });

    return { renderedRows };
  },
};
</script>

<style>
.first-section {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  padding: 40px;
  background-color: #ffffff;
}

.first-section .container {
  max-width: 1320px;
  margin: auto;
}

@media (max-width: 768px) {
  .first-section {
    padding: 50px 20px;
  }
}

.second-section {
  background: #f9f9f9;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}

@media (max-width: 768px) {
  .second-section {
    padding: 50px 20px;
  }
}

@media (max-width: 768px) {
  .single-column {
    margin-bottom: 0px !important;
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
}

.background-image {
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 350px;
}

@media (max-width: 768px) {
  .background-image {
    background-size: cover;
    min-height: 200px;
  }
}

.content-text {
  color: #757575;
  font-size: 20px;
  line-height: 30px;
}

@media (max-width: 768px) {
  .content-text {
    font-size: 18px;
    line-height: 28px;
  }
}

.section-column {
  padding-top: 30px;
  padding-bottom: 30px;
}

@media (max-width: 768px) {
  .section-column {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}

.single-column {
  margin-bottom: 0px !important;
  margin-left: 9rem;
  margin-right: 9rem;
}

/* ── Quill: alineación ── */
.ql-align-center  { text-align: center; }
.ql-align-right   { text-align: right; }
.ql-align-left    { text-align: left; }
.ql-align-justify { text-align: justify; }

.ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}

/* ── Quill: tamaños de fuente ── */
.ql-size-small { font-size: 0.75em; }
.ql-size-large { font-size: 1.5em; }
.ql-size-huge  { font-size: 2.5em; }

/* ── Quill: familias tipográficas ── */
.ql-font-serif     { font-family: Georgia, "Times New Roman", serif; }
.ql-font-monospace { font-family: Monaco, "Courier New", monospace; }

/* ── Quill: indentación (bloques) ── */
.ql-indent-1 { padding-left: 3em; }
.ql-indent-2 { padding-left: 6em; }
.ql-indent-3 { padding-left: 9em; }
.ql-indent-4 { padding-left: 12em; }
.ql-indent-5 { padding-left: 15em; }
.ql-indent-6 { padding-left: 18em; }
.ql-indent-7 { padding-left: 21em; }
.ql-indent-8 { padding-left: 24em; }

/* RTL */
.ql-direction-rtl .ql-indent-1 { padding-right: 3em; padding-left: 0; }
.ql-direction-rtl .ql-indent-2 { padding-right: 6em; padding-left: 0; }
.ql-direction-rtl .ql-indent-3 { padding-right: 9em; padding-left: 0; }
.ql-direction-rtl .ql-indent-4 { padding-right: 12em; padding-left: 0; }
.ql-direction-rtl .ql-indent-5 { padding-right: 15em; padding-left: 0; }
.ql-direction-rtl .ql-indent-6 { padding-right: 18em; padding-left: 0; }
.ql-direction-rtl .ql-indent-7 { padding-right: 21em; padding-left: 0; }
.ql-direction-rtl .ql-indent-8 { padding-right: 24em; padding-left: 0; }

/* ── Quill: listas ── */
ol, ul {
  padding-left: 1.5em;
  margin: 0;
}

ol { list-style-type: decimal; }
ul { list-style-type: disc; }

/* Listas anidadas con indentación */
li.ql-indent-1 { padding-left: 4.5em; }
li.ql-indent-2 { padding-left: 7.5em; }
li.ql-indent-3 { padding-left: 10.5em; }
li.ql-indent-4 { padding-left: 13.5em; }
li.ql-indent-5 { padding-left: 16.5em; }
li.ql-indent-6 { padding-left: 19.5em; }
li.ql-indent-7 { padding-left: 22.5em; }
li.ql-indent-8 { padding-left: 25.5em; }

/* Profundidad de listas ordenadas anidadas */
ol li.ql-indent-1 { list-style-type: lower-alpha; }
ol li.ql-indent-2 { list-style-type: lower-roman; }
ol li.ql-indent-3 { list-style-type: decimal; }
ol li.ql-indent-4 { list-style-type: lower-alpha; }
ol li.ql-indent-5 { list-style-type: lower-roman; }
ol li.ql-indent-6 { list-style-type: decimal; }
ol li.ql-indent-7 { list-style-type: lower-alpha; }
ol li.ql-indent-8 { list-style-type: lower-roman; }

/* Profundidad de listas no ordenadas anidadas */
ul li.ql-indent-1 { list-style-type: circle; }
ul li.ql-indent-2 { list-style-type: square; }
ul li.ql-indent-3 { list-style-type: disc; }

/* ── Quill: citas ── */
blockquote {
  border-left: 4px solid #ccc;
  margin: 0.5em 0;
  padding-left: 1em;
  color: #555;
}

/* ── Quill: código ── */
code {
  background-color: #f0f0f0;
  border-radius: 3px;
  font-family: Monaco, "Courier New", monospace;
  font-size: 0.875em;
  padding: 0.1em 0.3em;
}

pre.ql-syntax {
  background-color: #23241f;
  border-radius: 4px;
  color: #f8f8f2;
  font-family: Monaco, "Courier New", monospace;
  font-size: 0.875em;
  overflow: visible;
  padding: 1em;
  white-space: pre-wrap;
}
</style>
